import React from 'react';
import PropTypes from 'prop-types';
import { createFragmentContainer, graphql } from 'react-relay';
import { FormattedMessage } from 'react-intl';
import classNames from 'classnames';

import styles from './styles/CartItemImage.scss';

const ItemUnavailable = () => {
    return (
        <div className={styles.unavailable} data-tn="product-result-image-unavailable">
            <div className={styles.unavailableText}>
                <FormattedMessage
                    id="CartItemImage.notAvailable"
                    defaultMessage="Image Not Available"
                />
            </div>
        </div>
    );
};

const CartItemImage = ({ item, onClickProductImage }) => {
    const imageUnavailable = !item.firstPhotoWebPath;
    const wrapClasses = classNames(styles.imageWrap, {
        [styles.imageUnavailable]: imageUnavailable,
    });

    return (
        <div className="rowFlex">
            <div className={wrapClasses}>
                {imageUnavailable ? (
                    <ItemUnavailable />
                ) : (
                    <a
                        className={styles.imageLink}
                        data-tn="product-result-image-anchor"
                        onClick={onClickProductImage}
                        href={item.pdpURL}
                    >
                        <img
                            className={styles.image}
                            data-tn="product-result-image"
                            src={item.firstPhotoWebPath}
                            alt={item.title}
                        />
                    </a>
                )}
            </div>
        </div>
    );
};

CartItemImage.propTypes = {
    item: PropTypes.object.isRequired,
    onClickProductImage: PropTypes.func.isRequired,
};

CartItemImage.defaultProps = {
    onClickProductImage: () => {},
};

export default createFragmentContainer(CartItemImage, {
    item: graphql`
        fragment CartItemImage_item on Item {
            firstPhotoWebPath(size: large)
            pdpURL
            title
        }
    `,
});
